import { Button, Rate } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import React from "react";
import { TimeLine } from "../TimeLine";
import { TimeLineInList } from "../TimeLineInList";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface IProps {
  activeTableId?: string;
  infoTable?: any;
  disableUp?: boolean;
  disableDown?: boolean;
  handleSelectTable: (tableId?: string) => void;
  handleSortTable: (tableId: string, isDown?: boolean) => void;
}

function TableItem({
  activeTableId,
  infoTable,
  disableDown,
  disableUp,
  handleSelectTable,
  handleSortTable,
}: IProps) {
  return (
    <div className={styles.tableItemContainer}>
      <div className={styles.colCodeInfo}>
        <div
          className={styles.infoAlpha}
        >{`${infoTable?.tableConfig?.code}${infoTable?.tableConfig?.no}`}</div>
        <Button
          className={classNames(styles.btnSelect, {
            [styles.active]: activeTableId === infoTable?._id,
          })}
          onClick={() => handleSelectTable(infoTable?._id)}
        >
          {activeTableId === infoTable?._id ? "選択中" : "選択する"}
        </Button>
        <div className={styles.sortContainer}>
          <Button
            disabled={disableUp}
            onClick={() => handleSortTable(infoTable?._id)}
          >
            <UpOutlined />
          </Button>
          <Button
            onClick={() => handleSortTable(infoTable?._id, true)}
            disabled={disableDown}
          >
            <DownOutlined />
          </Button>
        </div>
      </div>
      <div className={styles.timeLineContainer}>
        <TimeLineInList
          courseTime={infoTable?.tableConfig?.courseTime}
          startTime={infoTable?.tableConfig?.startTime}
          intervalTime={infoTable?.tableConfig?.intervalTime}
          timer={infoTable?.tableConfig?.timer}
          takuId={infoTable?.id}
          infoTable={infoTable}
          activeTableId={activeTableId}
          formListTable={true}
          countNextBtn={Number(infoTable?.step)}
          cls={styles.timeLineInList}
        />
      </div>
    </div>
  );
}
export default TableItem;
